import AWS from 'aws-sdk';

const accessParams = {
  accessKeyId: process.env.MIX_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.MIX_AWS_SECRET_ACCESS_KEY,
  region: process.env.MIX_AWS_DEFAULT_REGION,
};

const s3 = new AWS.S3(accessParams);

export const fetchImagesFromS3Bucket = async (bucketName, path) => {
  try {
    const s3Params  = {
      Bucket: bucketName, 
    };

    if(path){
      s3Params['Key']= path;
    }
    const file = await s3
      .getObject(s3Params)
      .promise();
    const base64String = Buffer.from(file.Body).toString('base64');
    const avatarSrc = `data:image/jpeg;base64,${base64String}`;

    return avatarSrc;
  } catch (err) {
    console.log("Error ", err);
    return err;
  }
};